import Axios, {AxiosRequestConfig, AxiosResponse} from 'axios';
import router from '@/router';

export default class Client {
    private http = Axios.create();

    constructor() {
        this.http.interceptors.response.use(
            this.succeedHandling.bind(this),
            this.errorHandling.bind(this),
        );
    }

    public async get<T = any, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
        return this.http.get(url, config);
    }

    public async post<T = any, R = AxiosResponse<T>>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R> {
        return this.http.post(url, data, config);
    }

    private succeedHandling(response: AxiosResponse): AxiosResponse {
        return response;
    }

    private errorHandling(error: any): Promise<unknown> {
        if (401 === error.response.status) {
            router.push({name: 'expire'});
            return Promise.reject(error.response);
        }

        if (503 === error.response.status) {
            router.push({name: 'maintenance'});
            return Promise.reject(error.response);
        }

        if (500 <= error.response.status) {
            router.push({name: 'systemerror'});
            return Promise.reject(error.response);
        }
        return Promise.reject(error.response);
    }
}
